export const CiviliteMap = {
  MADAME: 'Madame',
  MONSIEUR: 'Monsieur',
} as const;

export type CiviliteCode = keyof typeof CiviliteMap;

export const RoleMap = {
  ADMIN: 'ADMIN',
  CONSEILLER: 'CONSEILLER',
  DIRIGEANT: 'DIRIGEANT',
  GESTIONNAIRE: 'GESTIONNAIRE',
  TARIFICATEUR: 'TARIFICATEUR',
} as const;

export type RoleCode = (typeof RoleMap)[keyof typeof RoleMap];

export const repetitionIndexList = [
  'Bis',
  'Ter',
  'A',
  'C',
  'D',
  'E',
  'F',
  'G',
  'H',
  'I',
  'J',
  'K',
  'L',
  'M',
  'N',
  'O',
  'P',
  'Q',
  'R',
  'S',
  'V',
  'W',
  'X',
  'Y',
  'Z',
] as const;

export type RepetitionIndex = (typeof repetitionIndexList)[number];
